import { render, staticRenderFns } from "./TemplateEditPageContent.vue?vue&type=template&id=1271038c&scoped=true"
import script from "./TemplateEditPageContent.vue?vue&type=script&lang=js"
export * from "./TemplateEditPageContent.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditPageContent.vue?vue&type=style&index=0&id=1271038c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271038c",
  null
  
)

export default component.exports